const defaultSets = [
    {
        desc: 'AUDC6+1 w/ keyboard (low pure/buzzy + buzzy)',
        keyboard: 'us',
        hasPiano: true,
        sounds: [
            {
                t: 1,
                f: 11,
                p: 'f3',
                key: '\\',
            },
            {
                t: 1,
                f: 13,
                p: 'd3',
                key: ']',
            },
            {
                t: 1,
                f: 14,
                p: 'c3#',
                key: '=',
            },
            {
                t: 1,
                f: 15,
                p: 'c3',
                key: '[',
            },
            {
                t: 1,
                f: 16,
                p: 'b2',
                key: 'p',
            },
            {
                t: 1,
                f: 18,
                p: 'a2',
                key: 'o',
            },
            {
                t: 1,
                f: 23,
                p: 'f2',
                key: 'u',
            },
            {
                t: 1,
                f: 28,
                p: 'd2',
                key: 't',
            },
            {
                t: 1,
                f: 31,
                p: 'c2',
                key: 'r',
            },
            {
                t: 6,
                f: 20,
                p: 'g1',
                key: 'b',
            },
            {
                t: 6,
                f: 21,
                p: 'f1#',
                key: 'g',
            },
            {
                t: 6,
                f: 22,
                p: 'f1',
                key: 'v',
            },
            {
                t: 6,
                f: 24,
                p: 'e1',
                key: 'c',
            },
            {
                t: 6,
                f: 25,
                p: 'd1#',
                key: 'd',
            },
            {
                t: 6,
                f: 27,
                p: 'd1',
                key: 'x',
            },
            {
                t: 6,
                f: 28,
                p: 'c1#',
                key: 's',
            },
            {
                t: 6,
                f: 30,
                p: 'c1',
                key: 'z',
            },
            {
                t: 1,
                f: 19,
                p: 'g2#',
                key: '9',
            },
            {
                t: 1,
                f: 22,
                p: 'f2#',
                key: '8',
            },
            {
                t: 1,
                f: 26,
                p: 'd2#',
                key: '6',
            },
            {
                t: 1,
                f: 29,
                p: 'c2#',
                key: '5',
            },
            {
                t: 1,
                f: 17,
                p: 'a2#',
                key: '0',
            },
        ],
    },
    {
        desc: 'AUDC6+8 w/ keyboard (pure/buzzy + white noise fake pitch drums )',
        keyboard: 'us',
        hasPiano: true,
        sounds: [
            {
                t: 8,
                f: 6,
                p: 'a2',
                key: "'",
            },
            {
                t: 8,
                f: 11,
                p: 'g2',
                key: ';',
            },
            {
                t: 8,
                f: 13,
                p: 'f2',
                key: 'l',
            },
            {
                t: 8,
                f: 17,
                p: 'e2',
                key: 'k',
            },
            {
                t: 8,
                f: 19,
                p: 'd2',
                key: 'j',
            },
            {
                t: 8,
                f: 31,
                p: 'c2',
                key: 'h',
            },
            {
                t: 6,
                f: 20,
                v: 15,
                p: 'g1',
                key: 'b',
            },
            {
                t: 6,
                f: 21,
                v: 15,
                p: 'f1#',
                key: 'g',
            },
            {
                t: 6,
                f: 22,
                v: 15,
                p: 'f1',
                key: 'v',
            },
            {
                t: 6,
                f: 24,
                v: 15,
                p: 'e1',
                key: 'c',
            },
            {
                t: 6,
                f: 25,
                v: 15,
                p: 'd1#',
                key: 'd',
            },
            {
                t: 6,
                f: 27,
                v: 15,
                p: 'd1',
                key: 'x',
            },
            {
                t: 6,
                f: 28,
                v: 15,
                p: 'c1#',
                key: 's',
            },
            {
                t: 6,
                f: 30,
                v: 15,
                p: 'c1',
                key: 'z',
            },
        ],
    },
    {
        desc: 'blend AUDC4/12 w/ keyboard (pure)',
        keyboard: 'us',
        hasPiano: true,
        sounds: [
            {
                t: 4,
                f: 3,
                p: 'b7',
                key: '.',
            },
            {
                t: 4,
                f: 4,
                p: 'g7',
                key: 'l',
            },
            {
                t: 4,
                f: 5,
                p: 'e7',
                key: 'o',
            },
            {
                t: 4,
                f: 7,
                p: 'b6',
                key: ',',
            },
            {
                t: 4,
                f: 8,
                p: 'a6',
                key: 'k',
            },
            {
                t: 4,
                f: 9,
                p: 'g6',
                key: 'i',
            },
            {
                t: 4,
                f: 14,
                p: 'c6',
                key: 'j',
            },
            {
                t: 4,
                f: 15,
                p: 'b5',
                key: 'u',
            },
            {
                t: 4,
                f: 13,
                p: 'c6#',
                key: 'm',
            },
            {
                t: 4,
                f: 18,
                p: 'g5#',
                key: 'n',
            },
            {
                t: 4,
                f: 19,
                p: 'g5',
                key: 'h',
            },
            {
                t: 4,
                f: 20,
                p: 'f5#',
                key: 'y',
            },
            {
                t: 4,
                f: 24,
                p: 'd5#',
                key: 'b',
            },
            {
                t: 4,
                f: 26,
                p: 'd5',
                key: 'g',
            },
            {
                t: 4,
                f: 27,
                p: 'c5#',
                key: 't',
            },
            {
                t: 4,
                f: 31,
                p: 'b4',
                key: 'v',
            },
            {
                t: 12,
                f: 11,
                p: 'a4',
                key: 'f',
            },
            {
                t: 12,
                f: 13,
                p: 'f4#',
                key: 'r',
            },
            {
                t: 12,
                f: 15,
                p: 'e4',
                key: 'c',
            },
            {
                t: 12,
                f: 16,
                p: 'd4#',
                key: 'd',
            },
            {
                t: 12,
                f: 17,
                p: 'd4',
                key: 'e',
            },
            {
                t: 12,
                f: 19,
                p: 'c4',
                key: 'x',
            },
            {
                t: 12,
                f: 20,
                p: 'b3',
                key: 's',
            },
            {
                t: 12,
                f: 23,
                p: 'a3',
                key: 'w',
            },
            {
                t: 12,
                f: 26,
                p: 'g3',
                key: 'z',
            },
            {
                t: 12,
                f: 27,
                p: 'f3#',
                key: 'a',
            },
            {
                t: 12,
                f: 29,
                p: 'f3',
                key: 'q',
            },
            {
                t: 4,
                f: 6,
                p: 'c7#',
                key: '9',
            },
            {
                t: 4,
                f: 11,
                p: 'e6',
                key: '8',
            },
            {
                t: 4,
                f: 16,
                p: 'a5#',
                key: '7',
            },
            {
                t: 4,
                f: 23,
                p: 'e5',
                key: '6',
            },
            {
                t: 4,
                f: 29,
                p: 'c5',
                key: '5',
            },
            {
                t: 12,
                f: 14,
                p: 'f4',
                key: '4',
            },
            {
                t: 12,
                f: 18,
                p: 'c4#',
                key: '3',
            },
            {
                t: 12,
                f: 24,
                p: 'g3#',
                key: '2',
            },
            {
                t: 12,
                f: 31,
                p: 'e3',
                key: '1',
            },
        ],
    },
    {
        desc: 'simple AUDC 1 - buzzy',
        keyboard: 'us',
        hasPiano: false,
        sounds: [
            {
                t: 1,
                f: 0,
                key: '.',
            },
            {
                t: 1,
                f: 1,
                key: ',',
            },
            {
                t: 1,
                f: 2,
                key: 'm',
            },
            {
                t: 1,
                f: 3,
                key: 'n',
            },
            {
                t: 1,
                f: 4,
                key: 'b',
            },
            {
                t: 1,
                f: 5,
                key: 'v',
            },
            {
                t: 1,
                f: 6,
                key: 'c',
            },
            {
                t: 1,
                f: 7,
                key: 'x',
            },
            {
                t: 1,
                f: 8,
                key: 'z',
            },
            {
                t: 1,
                f: 9,
                key: "'",
            },
            {
                t: 1,
                f: 10,
                key: ';',
            },
            {
                t: 1,
                f: 11,
                key: 'l',
            },
            {
                t: 1,
                f: 12,
                key: 'k',
            },
            {
                t: 1,
                f: 13,
                key: 'j',
            },
            {
                t: 1,
                f: 14,
                key: 'h',
            },
            {
                t: 1,
                f: 15,
                key: 'g',
            },
            {
                t: 1,
                f: 16,
                key: 'f',
            },
            {
                t: 1,
                f: 17,
                key: 'd',
            },
            {
                t: 1,
                f: 18,
                key: 's',
            },
            {
                t: 1,
                f: 19,
                key: 'a',
            },
            {
                t: 1,
                f: 20,
                key: ']',
            },
            {
                t: 1,
                f: 21,
                key: '[',
            },
            {
                t: 1,
                f: 22,
                key: 'p',
            },
            {
                t: 1,
                f: 23,
                key: 'o',
            },
            {
                t: 1,
                f: 24,
                key: 'i',
            },
            {
                t: 1,
                f: 25,
                key: 'u',
            },
            {
                t: 1,
                f: 26,
                key: 'y',
            },
            {
                t: 1,
                f: 27,
                key: 't',
            },
            {
                t: 1,
                f: 28,
                key: 'r',
            },
            {
                t: 1,
                f: 29,
                key: 'e',
            },
            {
                t: 1,
                f: 30,
                key: 'w',
            },
            {
                t: 1,
                f: 31,
                key: 'q',
            },
        ],
    },
    {
        desc: 'simple AUDC 2 - buzzy/ramble',
        keyboard: 'us',
        hasPiano: false,
        sounds: [
            {
                t: 2,
                f: 0,
                key: '.',
            },
            {
                t: 2,
                f: 1,
                key: ',',
            },
            {
                t: 2,
                f: 2,
                key: 'm',
            },
            {
                t: 2,
                f: 3,
                key: 'n',
            },
            {
                t: 2,
                f: 4,
                key: 'b',
            },
            {
                t: 2,
                f: 5,
                key: 'v',
            },
            {
                t: 2,
                f: 6,
                key: 'c',
            },
            {
                t: 2,
                f: 7,
                key: 'x',
            },
            {
                t: 2,
                f: 8,
                key: 'z',
            },
            {
                t: 2,
                f: 9,
                key: "'",
            },
            {
                t: 2,
                f: 10,
                key: ';',
            },
            {
                t: 2,
                f: 11,
                key: 'l',
            },
            {
                t: 2,
                f: 12,
                key: 'k',
            },
            {
                t: 2,
                f: 13,
                key: 'j',
            },
            {
                t: 2,
                f: 14,
                key: 'h',
            },
            {
                t: 2,
                f: 15,
                key: 'g',
            },
            {
                t: 2,
                f: 16,
                key: 'f',
            },
            {
                t: 2,
                f: 17,
                key: 'd',
            },
            {
                t: 2,
                f: 18,
                key: 's',
            },
            {
                t: 2,
                f: 19,
                key: 'a',
            },
            {
                t: 2,
                f: 20,
                key: ']',
            },
            {
                t: 2,
                f: 21,
                key: '[',
            },
            {
                t: 2,
                f: 22,
                key: 'p',
            },
            {
                t: 2,
                f: 23,
                key: 'o',
            },
            {
                t: 2,
                f: 24,
                key: 'i',
            },
            {
                t: 2,
                f: 25,
                key: 'u',
            },
            {
                t: 2,
                f: 26,
                key: 'y',
            },
            {
                t: 2,
                f: 27,
                key: 't',
            },
            {
                t: 2,
                f: 28,
                key: 'r',
            },
            {
                t: 2,
                f: 29,
                key: 'e',
            },
            {
                t: 2,
                f: 30,
                key: 'w',
            },
            {
                t: 2,
                f: 31,
                key: 'q',
            },
        ],
    },
    {
        desc: 'simple AUDC 3 - flangy/wavering',
        keyboard: 'us',
        hasPiano: false,
        sounds: [
            {
                t: 3,
                f: 0,
                key: '.',
            },
            {
                t: 3,
                f: 1,
                key: ',',
            },
            {
                t: 3,
                f: 2,
                key: 'm',
            },
            {
                t: 3,
                f: 3,
                key: 'n',
            },
            {
                t: 3,
                f: 4,
                key: 'b',
            },
            {
                t: 3,
                f: 5,
                key: 'v',
            },
            {
                t: 3,
                f: 6,
                key: 'c',
            },
            {
                t: 3,
                f: 7,
                key: 'x',
            },
            {
                t: 3,
                f: 8,
                key: 'z',
            },
            {
                t: 3,
                f: 9,
                key: "'",
            },
            {
                t: 3,
                f: 10,
                key: ';',
            },
            {
                t: 3,
                f: 11,
                key: 'l',
            },
            {
                t: 3,
                f: 12,
                key: 'k',
            },
            {
                t: 3,
                f: 13,
                key: 'j',
            },
            {
                t: 3,
                f: 14,
                key: 'h',
            },
            {
                t: 3,
                f: 15,
                key: 'g',
            },
            {
                t: 3,
                f: 16,
                key: 'f',
            },
            {
                t: 3,
                f: 17,
                key: 'd',
            },
            {
                t: 3,
                f: 18,
                key: 's',
            },
            {
                t: 3,
                f: 19,
                key: 'a',
            },
            {
                t: 3,
                f: 20,
                key: ']',
            },
            {
                t: 3,
                f: 21,
                key: '[',
            },
            {
                t: 3,
                f: 22,
                key: 'p',
            },
            {
                t: 3,
                f: 23,
                key: 'o',
            },
            {
                t: 3,
                f: 24,
                key: 'i',
            },
            {
                t: 3,
                f: 25,
                key: 'u',
            },
            {
                t: 3,
                f: 26,
                key: 'y',
            },
            {
                t: 3,
                f: 27,
                key: 't',
            },
            {
                t: 3,
                f: 28,
                key: 'r',
            },
            {
                t: 3,
                f: 29,
                key: 'e',
            },
            {
                t: 3,
                f: 30,
                key: 'w',
            },
            {
                t: 3,
                f: 31,
                key: 'q',
            },
        ],
    },
    {
        desc: 'simple AUDC 4 - pure',
        keyboard: 'us',
        hasPiano: false,
        sounds: [
            {
                t: 4,
                f: 1,
                key: ',',
            },
            {
                t: 4,
                f: 2,
                key: 'm',
            },
            {
                t: 4,
                f: 3,
                key: 'n',
            },
            {
                t: 4,
                f: 4,
                key: 'b',
            },
            {
                t: 4,
                f: 5,
                key: 'v',
            },
            {
                t: 4,
                f: 6,
                key: 'c',
            },
            {
                t: 4,
                f: 7,
                key: 'x',
            },
            {
                t: 4,
                f: 8,
                key: 'z',
            },
            {
                t: 4,
                f: 9,
                key: "'",
            },
            {
                t: 4,
                f: 10,
                key: ';',
            },
            {
                t: 4,
                f: 11,
                key: 'l',
            },
            {
                t: 4,
                f: 12,
                key: 'k',
            },
            {
                t: 4,
                f: 13,
                key: 'j',
            },
            {
                t: 4,
                f: 14,
                key: 'h',
            },
            {
                t: 4,
                f: 15,
                key: 'g',
            },
            {
                t: 4,
                f: 16,
                key: 'f',
            },
            {
                t: 4,
                f: 17,
                key: 'd',
            },
            {
                t: 4,
                f: 18,
                key: 's',
            },
            {
                t: 4,
                f: 19,
                key: 'a',
            },
            {
                t: 4,
                f: 20,
                key: ']',
            },
            {
                t: 4,
                f: 21,
                key: '[',
            },
            {
                t: 4,
                f: 22,
                key: 'p',
            },
            {
                t: 4,
                f: 23,
                key: 'o',
            },
            {
                t: 4,
                f: 24,
                key: 'i',
            },
            {
                t: 4,
                f: 25,
                key: 'u',
            },
            {
                t: 4,
                f: 26,
                key: 'y',
            },
            {
                t: 4,
                f: 27,
                key: 't',
            },
            {
                t: 4,
                f: 28,
                key: 'r',
            },
            {
                t: 4,
                f: 29,
                key: 'e',
            },
            {
                t: 4,
                f: 30,
                key: 'w',
            },
            {
                t: 4,
                f: 31,
                key: 'q',
            },
        ],
    },
    {
        desc: 'simple AUDC 6 - pure/buzzy',
        keyboard: 'us',
        hasPiano: false,
        sounds: [
            {
                t: 6,
                f: 0,
                key: '.',
            },
            {
                t: 6,
                f: 1,
                key: ',',
            },
            {
                t: 6,
                f: 2,
                key: 'm',
            },
            {
                t: 6,
                f: 3,
                key: 'n',
            },
            {
                t: 6,
                f: 4,
                key: 'b',
            },
            {
                t: 6,
                f: 5,
                key: 'v',
            },
            {
                t: 6,
                f: 6,
                key: 'c',
            },
            {
                t: 6,
                f: 7,
                key: 'x',
            },
            {
                t: 6,
                f: 8,
                key: 'z',
            },
            {
                t: 6,
                f: 9,
                key: "'",
            },
            {
                t: 6,
                f: 10,
                key: ';',
            },
            {
                t: 6,
                f: 11,
                key: 'l',
            },
            {
                t: 6,
                f: 12,
                key: 'k',
            },
            {
                t: 6,
                f: 13,
                key: 'j',
            },
            {
                t: 6,
                f: 14,
                key: 'h',
            },
            {
                t: 6,
                f: 15,
                key: 'g',
            },
            {
                t: 6,
                f: 16,
                key: 'f',
            },
            {
                t: 6,
                f: 17,
                key: 'd',
            },
            {
                t: 6,
                f: 18,
                key: 's',
            },
            {
                t: 6,
                f: 19,
                key: 'a',
            },
            {
                t: 6,
                f: 20,
                key: ']',
            },
            {
                t: 6,
                f: 21,
                key: '[',
            },
            {
                t: 6,
                f: 22,
                key: 'p',
            },
            {
                t: 6,
                f: 23,
                key: 'o',
            },
            {
                t: 6,
                f: 24,
                key: 'i',
            },
            {
                t: 6,
                f: 25,
                key: 'u',
            },
            {
                t: 6,
                f: 26,
                key: 'y',
            },
            {
                t: 6,
                f: 27,
                key: 't',
            },
            {
                t: 6,
                f: 28,
                key: 'r',
            },
            {
                t: 6,
                f: 29,
                key: 'e',
            },
            {
                t: 6,
                f: 30,
                key: 'w',
            },
            {
                t: 6,
                f: 31,
                key: 'q',
            },
        ],
    },
    {
        desc: 'simple AUDC 7 - reedy/rumble',
        keyboard: 'us',
        hasPiano: false,
        sounds: [
            {
                t: 7,
                f: 0,
                key: '.',
            },
            {
                t: 7,
                f: 1,
                key: ',',
            },
            {
                t: 7,
                f: 2,
                key: 'm',
            },
            {
                t: 7,
                f: 3,
                key: 'n',
            },
            {
                t: 7,
                f: 4,
                key: 'b',
            },
            {
                t: 7,
                f: 5,
                key: 'v',
            },
            {
                t: 7,
                f: 6,
                key: 'c',
            },
            {
                t: 7,
                f: 7,
                key: 'x',
            },
            {
                t: 7,
                f: 8,
                key: 'z',
            },
            {
                t: 7,
                f: 9,
                key: "'",
            },
            {
                t: 7,
                f: 10,
                key: ';',
            },
            {
                t: 7,
                f: 11,
                key: 'l',
            },
            {
                t: 7,
                f: 12,
                key: 'k',
            },
            {
                t: 7,
                f: 13,
                key: 'j',
            },
            {
                t: 7,
                f: 14,
                key: 'h',
            },
            {
                t: 7,
                f: 15,
                key: 'g',
            },
            {
                t: 7,
                f: 16,
                key: 'f',
            },
            {
                t: 7,
                f: 17,
                key: 'd',
            },
            {
                t: 7,
                f: 18,
                key: 's',
            },
            {
                t: 7,
                f: 19,
                key: 'a',
            },
            {
                t: 7,
                f: 20,
                key: ']',
            },
            {
                t: 7,
                f: 21,
                key: '[',
            },
            {
                t: 7,
                f: 22,
                key: 'p',
            },
            {
                t: 7,
                f: 23,
                key: 'o',
            },
            {
                t: 7,
                f: 24,
                key: 'i',
            },
            {
                t: 7,
                f: 25,
                key: 'u',
            },
            {
                t: 7,
                f: 26,
                key: 'y',
            },
            {
                t: 7,
                f: 27,
                key: 't',
            },
            {
                t: 7,
                f: 28,
                key: 'r',
            },
            {
                t: 7,
                f: 29,
                key: 'e',
            },
            {
                t: 7,
                f: 30,
                key: 'w',
            },
            {
                t: 7,
                f: 31,
                key: 'q',
            },
        ],
    },
    {
        desc: 'simple AUDC 8 - white noise',
        keyboard: 'us',
        hasPiano: false,
        sounds: [
            {
                t: 8,
                f: 0,
                key: '.',
            },
            {
                t: 8,
                f: 1,
                key: ',',
            },
            {
                t: 8,
                f: 2,
                key: 'm',
            },
            {
                t: 8,
                f: 3,
                key: 'n',
            },
            {
                t: 8,
                f: 4,
                key: 'b',
            },
            {
                t: 8,
                f: 5,
                key: 'v',
            },
            {
                t: 8,
                f: 6,
                key: 'c',
            },
            {
                t: 8,
                f: 7,
                key: 'x',
            },
            {
                t: 8,
                f: 8,
                key: 'z',
            },
            {
                t: 8,
                f: 9,
                key: "'",
            },
            {
                t: 8,
                f: 10,
                key: ';',
            },
            {
                t: 8,
                f: 11,
                key: 'l',
            },
            {
                t: 8,
                f: 12,
                key: 'k',
            },
            {
                t: 8,
                f: 13,
                key: 'j',
            },
            {
                t: 8,
                f: 14,
                key: 'h',
            },
            {
                t: 8,
                f: 15,
                key: 'g',
            },
            {
                t: 8,
                f: 16,
                key: 'f',
            },
            {
                t: 8,
                f: 17,
                key: 'd',
            },
            {
                t: 8,
                f: 18,
                key: 's',
            },
            {
                t: 8,
                f: 19,
                key: 'a',
            },
            {
                t: 8,
                f: 20,
                key: ']',
            },
            {
                t: 8,
                f: 21,
                key: '[',
            },
            {
                t: 8,
                f: 22,
                key: 'p',
            },
            {
                t: 8,
                f: 23,
                key: 'o',
            },
            {
                t: 8,
                f: 24,
                key: 'i',
            },
            {
                t: 8,
                f: 25,
                key: 'u',
            },
            {
                t: 8,
                f: 26,
                key: 'y',
            },
            {
                t: 8,
                f: 27,
                key: 't',
            },
            {
                t: 8,
                f: 28,
                key: 'r',
            },
            {
                t: 8,
                f: 29,
                key: 'e',
            },
            {
                t: 8,
                f: 30,
                key: 'w',
            },
            {
                t: 8,
                f: 31,
                key: 'q',
            },
        ],
    },
    {
        desc: 'simple AUDC 12 - pure lower',
        keyboard: 'us',
        hasPiano: false,
        sounds: [
            {
                t: 12,
                f: 0,
                key: '.',
            },
            {
                t: 12,
                f: 1,
                key: ',',
            },
            {
                t: 12,
                f: 2,
                key: 'm',
            },
            {
                t: 12,
                f: 3,
                key: 'n',
            },
            {
                t: 12,
                f: 4,
                key: 'b',
            },
            {
                t: 12,
                f: 5,
                key: 'v',
            },
            {
                t: 12,
                f: 6,
                key: 'c',
            },
            {
                t: 12,
                f: 7,
                key: 'x',
            },
            {
                t: 12,
                f: 8,
                key: 'z',
            },
            {
                t: 12,
                f: 9,
                key: "'",
            },
            {
                t: 12,
                f: 10,
                key: ';',
            },
            {
                t: 12,
                f: 11,
                key: 'l',
            },
            {
                t: 12,
                f: 12,
                key: 'k',
            },
            {
                t: 12,
                f: 13,
                key: 'j',
            },
            {
                t: 12,
                f: 14,
                key: 'h',
            },
            {
                t: 12,
                f: 15,
                key: 'g',
            },
            {
                t: 12,
                f: 16,
                key: 'f',
            },
            {
                t: 12,
                f: 17,
                key: 'd',
            },
            {
                t: 12,
                f: 18,
                key: 's',
            },
            {
                t: 12,
                f: 19,
                key: 'a',
            },
            {
                t: 12,
                f: 20,
                key: ']',
            },
            {
                t: 12,
                f: 21,
                key: '[',
            },
            {
                t: 12,
                f: 22,
                key: 'p',
            },
            {
                t: 12,
                f: 23,
                key: 'o',
            },
            {
                t: 12,
                f: 24,
                key: 'i',
            },
            {
                t: 12,
                f: 25,
                key: 'u',
            },
            {
                t: 12,
                f: 26,
                key: 'y',
            },
            {
                t: 12,
                f: 27,
                key: 't',
            },
            {
                t: 12,
                f: 28,
                key: 'r',
            },
            {
                t: 12,
                f: 29,
                key: 'e',
            },
            {
                t: 12,
                f: 30,
                key: 'w',
            },
            {
                t: 12,
                f: 31,
                key: 'q',
            },
        ],
    },
    {
        desc: 'simple AUDC 14 - electronic/rumble',
        keyboard: 'us',
        hasPiano: false,
        sounds: [
            {
                t: 14,
                f: 0,
                key: '.',
            },
            {
                t: 14,
                f: 1,
                key: ',',
            },
            {
                t: 14,
                f: 2,
                key: 'm',
            },
            {
                t: 14,
                f: 3,
                key: 'n',
            },
            {
                t: 14,
                f: 4,
                key: 'b',
            },
            {
                t: 14,
                f: 5,
                key: 'v',
            },
            {
                t: 14,
                f: 6,
                key: 'c',
            },
            {
                t: 14,
                f: 7,
                key: 'x',
            },
            {
                t: 14,
                f: 8,
                key: 'z',
            },
            {
                t: 14,
                f: 9,
                key: "'",
            },
            {
                t: 14,
                f: 10,
                key: ';',
            },
            {
                t: 14,
                f: 11,
                key: 'l',
            },
            {
                t: 14,
                f: 12,
                key: 'k',
            },
            {
                t: 14,
                f: 13,
                key: 'j',
            },
            {
                t: 14,
                f: 14,
                key: 'h',
            },
            {
                t: 14,
                f: 15,
                key: 'g',
            },
            {
                t: 14,
                f: 16,
                key: 'f',
            },
            {
                t: 14,
                f: 17,
                key: 'd',
            },
            {
                t: 14,
                f: 18,
                key: 's',
            },
            {
                t: 14,
                f: 19,
                key: 'a',
            },
            {
                t: 14,
                f: 20,
                key: ']',
            },
            {
                t: 14,
                f: 21,
                key: '[',
            },
            {
                t: 14,
                f: 22,
                key: 'p',
            },
            {
                t: 14,
                f: 23,
                key: 'o',
            },
            {
                t: 14,
                f: 24,
                key: 'i',
            },
            {
                t: 14,
                f: 25,
                key: 'u',
            },
            {
                t: 14,
                f: 26,
                key: 'y',
            },
            {
                t: 14,
                f: 27,
                key: 't',
            },
            {
                t: 14,
                f: 28,
                key: 'r',
            },
            {
                t: 14,
                f: 29,
                key: 'e',
            },
            {
                t: 14,
                f: 30,
                key: 'w',
            },
            {
                t: 14,
                f: 31,
                key: 'q',
            },
        ],
    },
    {
        desc: 'simple AUDC 15 - electronic/rumble',
        keyboard: 'us',
        hasPiano: false,
        sounds: [
            {
                t: 15,
                f: 0,
                key: '.',
            },
            {
                t: 15,
                f: 1,
                key: ',',
            },
            {
                t: 15,
                f: 2,
                key: 'm',
            },
            {
                t: 15,
                f: 3,
                key: 'n',
            },
            {
                t: 15,
                f: 4,
                key: 'b',
            },
            {
                t: 15,
                f: 5,
                key: 'v',
            },
            {
                t: 15,
                f: 6,
                key: 'c',
            },
            {
                t: 15,
                f: 7,
                key: 'x',
            },
            {
                t: 15,
                f: 8,
                key: 'z',
            },
            {
                t: 15,
                f: 9,
                key: "'",
            },
            {
                t: 15,
                f: 10,
                key: ';',
            },
            {
                t: 15,
                f: 11,
                key: 'l',
            },
            {
                t: 15,
                f: 12,
                key: 'k',
            },
            {
                t: 15,
                f: 13,
                key: 'j',
            },
            {
                t: 15,
                f: 14,
                key: 'h',
            },
            {
                t: 15,
                f: 15,
                key: 'g',
            },
            {
                t: 15,
                f: 16,
                key: 'f',
            },
            {
                t: 15,
                f: 17,
                key: 'd',
            },
            {
                t: 15,
                f: 18,
                key: 's',
            },
            {
                t: 15,
                f: 19,
                key: 'a',
            },
            {
                t: 15,
                f: 20,
                key: ']',
            },
            {
                t: 15,
                f: 21,
                key: '[',
            },
            {
                t: 15,
                f: 22,
                key: 'p',
            },
            {
                t: 15,
                f: 23,
                key: 'o',
            },
            {
                t: 15,
                f: 24,
                key: 'i',
            },
            {
                t: 15,
                f: 25,
                key: 'u',
            },
            {
                t: 15,
                f: 26,
                key: 'y',
            },
            {
                t: 15,
                f: 27,
                key: 't',
            },
            {
                t: 15,
                f: 28,
                key: 'r',
            },
            {
                t: 15,
                f: 29,
                key: 'e',
            },
            {
                t: 15,
                f: 30,
                key: 'w',
            },
            {
                t: 15,
                f: 31,
                key: 'q',
            },
        ],
    },
];

export default defaultSets;
